import ProjectGroup from "./routes/ProjectGroup";
import { routes } from "./config/routes";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
const {
  projects: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import("./components"),
          import("Projects/modules/ProjectModules.js"),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1;
          injectReducer(store, {
            key: reducer.NAME,
            reducer: reducer.default,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProjectGroup(store)],
  };
};
